import React from "react";
import { SimpleHeader } from "./SimpleHeader";

interface BankAccountHeaderProps {
  title: string
  beneficiaryName: string
}

export const BankAccountHeader = ({ title, beneficiaryName }: BankAccountHeaderProps) =>
  <SimpleHeader title={title} isDeleted={false}>
    <div className="purple-header-text">{beneficiaryName}</div>
  </SimpleHeader>;
